import script from "./VatTuNgoaiDinhMucModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VatTuNgoaiDinhMucModal.vue?vue&type=script&setup=true&lang=ts"

import "./VatTuNgoaiDinhMucModal.vue?vue&type=style&index=0&id=42fb1838&lang=css"

const __exports__ = script;

export default __exports__